module.exports = __webpack_public_path__ + "img/prebutton_bg.f0c46402.png";